import { create } from "zustand";
import { Socket, io } from "socket.io-client";
import Cookies from "js-cookie";
import { ClientToServerEvents, ServerToClientEvents } from "@/types";

const chatURL = import.meta.env.VITE_CHAT_API_URI
  ? `${import.meta.env.VITE_CHAT_API_URI}`
  : "http://localhost:4000";

interface SocketState {
  socket: Socket<ServerToClientEvents, ClientToServerEvents> | null;
  connectSocket: (isLoggedIn: boolean) => void;
  disconnectSocket: () => void;
}

const useChatSocketStore = create<SocketState>((set, get) => ({
  socket: null,
  connectSocket: (isLoggedIn) => {
    const token = Cookies.get("jwtToken");

    const newSocket = io(chatURL, {
      autoConnect: false,
      withCredentials: true,
      auth: isLoggedIn && token ? { token } : undefined,
    });

    newSocket.connect();

    newSocket.on("connect", () => {
      console.log("Connected to the server with id:", newSocket.id);
      newSocket.emit("joinRoom", "f2e8fbd5-2897-4a25-a8d1-ffcb53b94abf");
    });

    newSocket.on("connect_error", (err) => {
      console.error("Connection error:", err.message || err);
    });

    set({ socket: newSocket });
  },
  disconnectSocket: () => {
    const socket = get().socket;
    if (socket) {
      socket.disconnect();
      set({ socket: null });
    }
  },
}));

export default useChatSocketStore;
